/**
 * PEFSA — Banner Quote Modal v2.3
 * Centered general-quote popup. Self-contained: does not depend on the theme Drawer.
 *
 * v2.3 — UX: focus() calls now use { preventScroll: true }. On close we return focus
 *        to the banner trigger; the browser was scrolling the page to reveal it, which
 *        pushed the top announcement bar out of view. preventScroll keeps the page put.
 *
 * v2.2 — UX: opening locks background scroll (overflow:hidden). That removed the
 *        scrollbar and made the page jump ~15px to the right. We now compensate that
 *        width with padding-right while the modal is open -> no horizontal jump.
 *
 * v2.1 — BUGFIX: reset() no longer clears dataset.pefsaInit nor re-inits the form.
 *        It used to duplicate the listeners on every open: the RFC toggle fired twice
 *        (open + close, i.e. did nothing) and submit was registered N times, which
 *        would have sent the same quote N times.
 *
 * Opens with:
 *   - <a href="#cotizar-banner">   (set from the theme editor)
 *   - any element with [data-banner-quote]
 *
 * Closes with: the X, click on the backdrop, or Escape.
 */

(function () {
  'use strict';

  var PREFIX = 'pefsa-banner';
  var lastFocused = null;

  function modal() { return document.getElementById('Banner-Quote-Modal'); }
  function form()  { return document.getElementById(PREFIX + '-quote-form'); }

  function setVal(id, v) {
    var el = document.getElementById(id);
    if (el) el.value = v || '';
  }

  // Clear the form WITHOUT touching the already-registered listeners.
  function reset() {
    var f         = form();
    var successEl = document.getElementById(PREFIX + '-quote-success');
    var errorEl   = document.getElementById(PREFIX + '-quote-error');
    var btn       = document.getElementById(PREFIX + '-quote-btn');
    var extraEl   = document.getElementById(PREFIX + '-details-extra');
    var toggleEl  = document.getElementById(PREFIX + '-details-toggle');
    var fileMsg   = document.getElementById(PREFIX + '-archivo-msg');

    if (f) {
      f.reset();
      f.style.display = '';
      // NOTE: do NOT clear f.dataset.pefsaInit. Clearing it duplicated the submit listener.
    }

    if (successEl) successEl.style.display = 'none';
    if (errorEl)   errorEl.style.display   = 'none';

    if (btn) {
      btn.disabled    = false;
      btn.textContent = 'Solicitar cotización';
    }

    if (extraEl) extraEl.style.display = 'none';

    if (toggleEl) {
      toggleEl.textContent = '+ Datos adicionales (RFC)';
      toggleEl.setAttribute('aria-expanded', 'false');
    }

    if (fileMsg) { fileMsg.textContent = ''; fileMsg.style.color = '#6b7280'; }

    setVal(PREFIX + '-archivo-b64', '');
    setVal(PREFIX + '-archivo-nombre', '');
    setVal(PREFIX + '-archivo-mime', '');

    // initForm is idempotent: its guards prevent duplicating listeners.
    if (window.PefsaQuoteForm && f) {
      window.PefsaQuoteForm.initForm(f);
    }
  }

  function open(trigger) {
    var m = modal();
    if (!m) return;

    lastFocused = trigger || document.activeElement;

    reset();

    var f = form();
    if (f) {
      var origen = f.querySelector('[name="origen_formulario"]');
      if (origen) origen.value = 'banner';

      setVal(PREFIX + '-ua', navigator.userAgent);

      if (window.PefsaQuoteForm) {
        window.PefsaQuoteForm.injectUTMs(f);
      }
    }

    // Scrollbar width BEFORE hiding it, to compensate for the horizontal jump.
    var scrollBarW = window.innerWidth - document.documentElement.clientWidth;

    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (scrollBarW > 0) document.body.style.paddingRight = scrollBarW + 'px';

    var first = m.querySelector('input[name="nombre"]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    var m = modal();
    if (!m || !m.classList.contains('is-open')) return;

    m.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-banner-quote], a[href="#cotizar-banner"], a[href$="#cotizar-banner"]');
    if (opener) {
      if (!modal()) return;
      e.preventDefault();
      e.stopPropagation();
      open(opener);
      return;
    }

    if (e.target.closest('[data-pefsa-modal-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) close();
  });

  window.PefsaBannerQuote = { open: open, close: close };

})();